// 導覽列導航
document.addEventListener('DOMContentLoaded', function () {
  const menu = document.getElementById('fix-menu');
  const isApp = Citiesocial.utils.isApp();
  const stickyThreshold = getStickyThreshold();
  let isUserScrolling = false;

  if (menu) {
    fixMenu();
    window.onscroll = function () {
      fixMenu();
    };
  }

  function getStickyThreshold() {
    if (window.countdownStickyMode && isApp) {
      return 0;
    }
    return menu?.offsetTop - getHeaderHeight();
  }

  function getHeaderHeight() {
    if (window.countdownStickyMode) {
      return $('.exclusive-product__countdown').height() || 0;
    } else {
      if (isApp) {
        return 0;
      }

      return (
        $('#shopify-section-header').height() +
        $('#shopify-section-top_bar').height()
      );
    }
  }

  function fixMenu() {
    if (window.scrollY > stickyThreshold) {
      menu.classList.add('sticky');
      $('.sticky').css('top', getHeaderHeight());
    } else {
      menu.classList.remove('sticky');
      $('.sticky').css('top', 'unset');
    }
  }

  $('.item').click(function () {
    $(this).siblings('.active').removeClass('active');
    $(this).addClass('active');

    // 判斷是否為第一個 item
    const isFirstItem = $(this).is(':first-child');
    const node = document.querySelector('#' + $(this).attr('data-tab'));

    let totalMenuHeight = 0;
    if (window.countdownStickyMode) {
      totalMenuHeight =
        ($('.exclusive-product__countdown').height() || 0) +
        $('#fix-menu').height();

      if (isFirstItem && $('#fix-menu').hasClass('sticky')) {
        totalMenuHeight = $('.exclusive-product__countdown').height() || 0;
      }

      if (!isFirstItem && !$('#fix-menu').hasClass('sticky')) {
        totalMenuHeight += $('#fix-menu').height();
      }
    } else {
      totalMenuHeight =
        $('#shopify-section-top_bar').height() +
        $('#shopify-section-header').height() +
        $('#fix-menu').height();

      if (isFirstItem && $('#fix-menu').hasClass('sticky')) {
        totalMenuHeight =
          $('#shopify-section-top_bar').height() +
          $('#shopify-section-header').height();
      }

      if (!isFirstItem && !$('#fix-menu').hasClass('sticky')) {
        totalMenuHeight += $('#fix-menu').height();
      }
    }

    if (node) {
      $('html, body').animate(
        {
          scrollTop: node.offsetTop - totalMenuHeight,
        },
        500,
      );
    }

    isUserScrolling = true;
    setTimeout(() => {
      isUserScrolling = false;
    }, 500);
  });

  const navItems = document.querySelectorAll('.nav-items .item');
  const sections = document.querySelectorAll('.nav-anchor');
  function activeNavItemOnSectionChange() {
    if (isUserScrolling) return;
    if (navItems.length === 0 || sections.length === 0) return;

    const checkPoint = window.screen.height / 2;
    let currentSection = sections[0];
    [...sections].forEach((item) => {
      const top = item.getBoundingClientRect().top;

      if (top > checkPoint) {
        return true;
      } else {
        currentSection = item;
        return false;
      }
    });

    const navItem = document.querySelector(
      `.item[data-tab="${currentSection.id}"]`,
    );

    if (!navItem) return;
    navItems.forEach((item) => item.classList.remove('active'));
    navItem?.classList?.add('active');

    setTimeout(() => {
      if (window.scrollY > stickyThreshold) {
        navItem?.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50);
  }

  const throttledActiveNavItemOnSectionChange = Citiesocial.utils.throttle(
    activeNavItemOnSectionChange,
    25,
  );

  document.addEventListener('scroll', throttledActiveNavItemOnSectionChange);
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < RESPONSIVE_MIDDLE_BREAKING_POINT) {
    document.documentElement.style.setProperty(
      '--highlight-card-width',
      `${document.body.clientWidth - 32 - 64}px`,
    );

    document.documentElement.style.setProperty(
      '--select-card-width',
      `${(document.body.clientWidth - 32) / 2 - 32}px`,
    );
  }

  async function fetchProductsByTopic() {
    const collectionShopifyIds = [];
    $('.theme__products-by-topic .topic__products-grid').each(
      (index, element) => {
        const collectionShopifyId = $(element).data('collection-id');
        if (collectionShopifyId) {
          collectionShopifyIds.push(
            `collection_shopify_id=${collectionShopifyId}`,
          );
        }
      },
    );

    const { collections } = await Citiesocial.productManager.fetchProducts({
      collectionHandle: MULTI_COLLECTION,
      collectionShopifyIds: collectionShopifyIds.join('&'),
    });
    collections.forEach((collection) => {
      const products =
        window.innerWidth < RESPONSIVE_MIDDLE_BREAKING_POINT
          ? collection.products.slice(0, 12)
          : collection.products.slice(0, 9);
      const productCardsHTML = Citiesocial.productManager.makeProductCardsHTML(
        products,
        {},
        {
          cardType: 'sale',
        },
      );

      $(`.topic__products-grid[data-collection-id="${collection.id}"]`).html(
        productCardsHTML,
      );
    });
  }

  async function fetchProductsByRecommendation() {
    const collectionShopifyIds = [];
    $('.selected-recommendation__products').each((index, element) => {
      const collectionShopifyId = $(element).data('collection-id');
      if (collectionShopifyId) {
        collectionShopifyIds.push(
          `collection_shopify_id=${collectionShopifyId}`,
        );
      }
    });

    const { collections } = await Citiesocial.productManager.fetchProducts({
      collectionHandle: MULTI_COLLECTION,
      collectionShopifyIds: collectionShopifyIds.join('&'),
    });
    collections.forEach((collection) => {
      const products = collection.products;
      const productCardsHTML = Citiesocial.productManager.makeProductCardsHTML(
        products,
        {},
        {
          cardType: 'sale',
        },
      );

      if (window.innerWidth >= RESPONSIVE_MIDDLE_BREAKING_POINT) {
        $(`[data-collection-id="${collection.id}"] .owl-carousel`).html(
          productCardsHTML,
        );
        const owlCarouselOptions = Citiesocial.productManager.makeOwlCarouselOptions(
          '',
          true,
        );
        owlCarouselOptions.responsive[
          RESPONSIVE_MIDDLE_BREAKING_POINT
        ].margin = 16;
        owlCarouselOptions.responsive[
          RESPONSIVE_LARGE_BREAKING_POINT
        ].margin = 16;
        $(`[data-collection-id="${collection.id}"] .owl-carousel`).owlCarousel(
          owlCarouselOptions,
        );
      } else {
        $(
          `[data-collection-id="${collection.id}"] .selected-recommendation__products-grid`,
        ).html(productCardsHTML);
      }
    });
  }

  async function showTopBannerCarousel() {
    const collectionShopifyIds = [];
    $('.top-banner-carousel__products').each((index, element) => {
      const collectionShopifyId = $(element).data('collection-id');
      if (collectionShopifyId) {
        collectionShopifyIds.push(
          `collection_shopify_id=${collectionShopifyId}`,
        );
      }
    });

    const { collections } = await Citiesocial.productManager.fetchProducts({
      collectionHandle: MULTI_COLLECTION,
      collectionShopifyIds: collectionShopifyIds.join('&'),
    });
    collections.forEach((collection) => {
      const products = collection.products;
      const productCardsHTML = Citiesocial.productManager.makeProductCardsHTML(
        products,
        {},
        {
          cardType: 'sale',
        },
      );

      if (window.innerWidth >= RESPONSIVE_MIDDLE_BREAKING_POINT) {
        $(`[data-collection-id="${collection.id}"] .owl-carousel`).html(
          productCardsHTML,
        );
        const owlCarouselOptions = Citiesocial.productManager.makeOwlCarouselOptions(
          '',
          true,
        );
        owlCarouselOptions.responsive[
          RESPONSIVE_MIDDLE_BREAKING_POINT
        ].margin = 16;
        owlCarouselOptions.responsive[
          RESPONSIVE_MIDDLE_BREAKING_POINT
        ].items = 5;
        owlCarouselOptions.responsive[
          RESPONSIVE_LARGE_BREAKING_POINT
        ].margin = 16;
        owlCarouselOptions.responsive[
          RESPONSIVE_LARGE_BREAKING_POINT
        ].items = 5;
        $(`[data-collection-id="${collection.id}"] .owl-carousel`).owlCarousel(
          owlCarouselOptions,
        );
      } else {
        $(`[data-collection-id="${collection.id}"] .list__list`).html(
          productCardsHTML,
        );
      }
    });
  }

  // 輪播商品顯示
  fetchProductsByTopic();
  fetchProductsByRecommendation();
  showTopBannerCarousel();

  // 滑動到主題區塊
  $('.topic-item').click(function () {
    const topic = $(this).attr('data-topic');

    $('html, body').animate(
      {
        scrollTop:
          $(`#${topic}`).offset().top -
          ($('#shopify-section-top_bar').height() || 0) -
          ($('#shopify-section-header').height() || 0) -
          ($('#fix-menu').height() || 0),
      },
      500,
    );
  });

  // 啟動 ref 參數
  setTimeout(function () {
    $('#main a').each(function () {
      if ($(this).hasClass('item')) {
        return;
      }

      $(this).attr('target', '_blank');
      const href = $(this).attr('href');
      const url = new URL(href, window.location.origin);
      const refLabel = $(this).closest('.ref-group').data('ref');
      if (!refLabel) {
        return;
      }

      url.searchParams.set('ref', refLabel);
      $(this).attr('href', url.toString());
    });
    Citiesocial.favoriteManager.start();
  }, 3000);

  // ==============================
  // 獨家新品相關
  function scrollToProduct() {
    // 如果有倒數計時器，top_bar 與 header 會移除 sticky 狀態
    // 因此不用考慮 top_bar 與 header 的高度
    if (window.countdownStickyMode) {
      $('html, body').animate(
        {
          scrollTop:
            $('.exclusive-product__products').offset().top -
            ($('.exclusive-product__countdown').height() || 0) -
            ($('#fix-menu').height() || 0),
        },
        500,
      );
      return;
    }

    $('html, body').animate(
      {
        scrollTop:
          $('.exclusive-product__products').offset().top -
          ($('#shopify-section-top_bar').height() || 0) -
          ($('#shopify-section-header').height() || 0) -
          ($('.exclusive-product__countdown').height() || 0) -
          ($('#fix-menu').height() || 0),
      },
      500,
    );
  }

  $(document).on('click', '.go-to-product__button', function () {
    scrollToProduct();
  });

  // 獨家新品訂閱
  $('main .exclusive-product__subscribe-button').click(function () {
    window.segmentTracking.exclusiveProductSubscribeClicked({
      title: `${document.title}`,
    });
    window.fbq('track', 'ExClusiveProductSubscribe');
    window.fbq('track', 'SubmitApplication');
  });
});

// 支援 anchor link 功能
document.addEventListener('DOMContentLoaded', function () {
  function computeHeaderOffset() {
    const selectors = [
      '#shopify-section-top_bar',
      '#shopify-section-header',
      '#fix-menu',
    ];

    const offsetMargin = 8; // 多留一點空隙
    let totalHeaderOffset = 0;
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (!element) continue;
      totalHeaderOffset += element.getBoundingClientRect().height;
    }
    totalHeaderOffset += offsetMargin;

    if (window.innerWidth < RESPONSIVE_MIDDLE_BREAKING_POINT) {
      document.documentElement.style.setProperty(
        '--anchor-mobile-offset',
        totalHeaderOffset + 'px',
      );
    } else {
      document.documentElement.style.setProperty(
        '--anchor-desktop-offset',
        totalHeaderOffset + 'px',
      );
    }
    return totalHeaderOffset;
  }

  if (!location.hash) return false;

  // 關掉瀏覽器的自動捲動還原（只在這頁且有 # 時關）
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  computeHeaderOffset();

  function scrollToHashIfPossible() {
    const id = decodeURIComponent(location.hash.slice(1));
    if (!id) return false;

    const targetElement =
      document.getElementById(id) || document.getElementsByName(id)[0];
    if (!targetElement) return false;

    // 雙 rAF 等待一次版面安定，再捲到精準位置（扣掉固定列）
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        const totalMenuHeight = computeHeaderOffset() || 0;

        setTimeout(() => {
          $('html, body').animate(
            {
              scrollTop:
                targetElement.getBoundingClientRect().top +
                window.scrollY -
                totalMenuHeight,
            },
            300,
          );
        }, 500);
      }),
    );
    return true;
  }

  // 先試一次；若目標尚未出現，用 MutationObserver 等待短時間
  if (scrollToHashIfPossible()) return;
  const t0 = performance.now();
  const mo = new MutationObserver(() => {
    if (scrollToHashIfPossible() || performance.now() - t0 > 3000) {
      mo.disconnect();
    }
  });
  mo.observe(document, { childList: true, subtree: true });
});
